<template>
  <!-- Escuchamos el evento desde el router-view -->
  <router-view @add-to-cart="handleAddToCart" />
  <ChatWidget />
</template>

<script setup>
import { ref } from 'vue'
import ChatWidget from '@/components/ChatWidget.vue' // O la ruta donde lo guardes
const cart = ref([])

const handleAddToCart = (product) => {
  // Lógica para agregar al carrito
  console.log("Agregado al carrito:", product)
  cart.value.push(product)
}
</script>